'use client';

import { ReactNode } from 'react';
import { usePathname } from 'next/navigation';

import Header from './Header';
import CorporateHeader from './CorporateHeader';
import Footer from './Footer';
import ImpersonationBanner from './ImpersonationBanner';

const CORPORATE_PATH_PREFIXES = ['/customer', '/pricing'];

export default function AppChrome({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const isCorporatePage = CORPORATE_PATH_PREFIXES.some((prefix) =>
    pathname?.startsWith(prefix)
  );

  if (isCorporatePage) {
    return (
      <>
        <CorporateHeader />
        <main className='flex-1 overflow-y-auto scroll mt-12'>{children}</main>
      </>
    );
  }

  return (
    <>
      <div style={{ position: 'relative' }}>
        <Header />
        <ImpersonationBanner />
      </div>
      <main className='flex-1 overflow-y-auto scroll mt-12 pb-20'>
        {children}
      </main>
      <Footer />
    </>
  );
}
